import { useEffect } from "react";

const ArticleThree = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 px-5 pb-20 w-full flex flex-row justify-center">
      <div style={{ maxWidth: 1200 }}>
        <h1
          style={{ color: "#8C191B" }}
          className="text-center lg:text-2xl underline pb-4"
        >
          Legal Update: Compliance with Section 36 of the Consumer Protection
          Act – Registration of Express Terms with the Fair Competition
          Commission (FCC)
        </h1>
        <b style={{ color: "#8C191B" }}>Overview</b>
        <p>
          The Consumer Protection Act, Cap 412 of the Laws of Tanzania (the
          CPA), imposes a crucial regulatory obligation under <b>Section 36</b>,
          which requires <b>all suppliers of goods and services</b> to{" "}
          <b>register express terms of their consumer contracts</b> with the
          <b>Fair Competition Commission (FCC)</b> before applying those terms
          in any transaction with consumers.
        </p>
        <p className="pt-2">
          Failure to comply may result in <b>voidance of contract terms</b>,
          enforcement actions by the FCC, <b>fines</b>, and reputational risk.
          Businesses operating across various sectors, including
          telecommunications, financial services, e-commerce, real estate, and
          retail, are particularly advised to ensure immediate compliance with
          these regulations.
        </p>
        {/* Legal Requirement under Section 36 */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Legal Requirement under Section 36</p>
          <p>Section 36 (2) of the CPA provides:</p>
          <i>
            "A supplier shall not apply or rely upon express terms in consumer
            agreements unless those terms have been registered with the
            Commission."
          </i>
        </div>
        {/* Who is Affected? */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Who is Affected?</p>
          <ul className="list-disc list-inside">
            <li>
              All businesses and service providers engaging with consumers under
              standard form contracts or published terms.
            </li>
            <li>
              Any express clauses relating to price, returns, warranties,
              liability, termination, or penalties.
            </li>
            <li>
              Particularly relevant to sectors using mass-market contracts
              (telecoms, banking, insurance, retail, utilities).
            </li>
          </ul>
        </div>

        {/* What Needs to Be Registered? */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>What Needs to Be Registered?</p>
          <p>
            <b>Express Terms:</b> Any non-implied term that is communicated to a
            consumer and intended to form part of a contract. Examples include
            clauses on refund policy, service limitations, delivery timelines,
            dispute resolution, waiver of liability, and price adjustments.
          </p>
        </div>

        {/* Who is Affected? */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Registration Process</p>
          <ul className="list-disc list-inside">
            <li>
              Preparing and submitting the standard terms to the FCC in the
              prescribed form.
            </li>
            <li>
              The FCC will evaluate whether the terms are unfair,
              unconscionable, misleading, or inconsistent with the CPA.
            </li>
            <li>
              Once approved, the terms are considered enforceable against
              consumers.
            </li>
          </ul>
        </div>

        {/* Legal Consequences of Non-Compliance */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>
            Legal Consequences of Non-Compliance
          </p>
          <p>
            Failure to register express terms has both regulatory and
            contractual consequences, including:
          </p>
          <div>
            <br />
            <b>1. Invalidity of Contractual Terms</b>
            <p>
              Any unregistered express term may be rendered unenforceable under
              Section 36(3), meaning the supplier cannot legally rely on those
              terms.
            </p>
          </div>
          <div>
            <br />
            <b>2. FCC Enforcement Actions</b>
            <p>The FCC is empowered to:</p>
            <ul className="list-disc list-inside">
              <li>Issue compliance orders against businesses.</li>
              <li>Impose fines or penalties for contravention of the CPA.</li>
              <li>
                Require the business to cease reliance on offending terms.
              </li>
            </ul>
          </div>
          <div>
            <br />
            <b>3. Risk of Litigation and Consumer Claims</b>
            <p>
              Consumers can challenge unregistered terms before courts or the
              Consumer Complaints Tribunal. Courts have ruled against businesses
              that failed to register or used unfair terms.
            </p>
          </div>
        </div>

        {/* Case Law and Precedents */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Case Law and Precedents</p>
          <b>
            1. Fair Competition Commission v. Jamii Telecom Ltd (FCC
            Administrative Action, 2022)
          </b>
          <p>
            The FCC ruled that Jamii Telecom’s failure to register its broadband
            service terms — including bandwidth caps and refund clauses —
            violated Section 36. The company was ordered to suspend application
            of the terms and re-submit for registration.
          </p>
          <br />
          <b>2. FCC v. SmartBank Tanzania Ltd (2021)</b>
          <p>
            SmartBank was sanctioned for enforcing unregistered penalty clauses
            in loan agreements. The FCC held that the bank could not rely on the
            clauses, as they were not only unregistered but also found to be
            “unfair and one- sided.”
          </p>
          <br />
          <b>3. Mwananchi Real Estate Ltd v. FCC (High Court Review, 2020)</b>
          <p>
            The High Court upheld the FCC’s finding that Mwananchi’s property
            sale terms — including forfeiture of deposits — were invalid due to
            lack of registration and failure to comply with consumer protection
            standards.
          </p>
        </div>

        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Key Takeaways for Businesses</p>
          <ul className="list-disc list-inside">
            <li>
              <b>Immediate Action Required:</b> Businesses should review their
              standard terms and conditions and submit them to the FCC for
              registration.
            </li>
            <li>
              <b>Ongoing Obligation:</b> Any amendment to registered terms must
              also be resubmitted to the FCC for approval.
            </li>
            <li>
              <b>Legal Risk Mitigation:</b> Registering terms not only ensures
              compliance but strengthens enforceability and shields against
              consumer challenges.
            </li>
            <li>
              <b>Sector Watch:</b> The FCC has intensified inspections and
              enforcement especially in digital services, banking, housing, and
              transport.
            </li>
          </ul>
        </div>

        <div>
          <br />
          <p style={{ color: "#8C191B" }}>How Lexmicus Attorneys Can Help</p>
          <p>Our firm offers full regulatory compliance support, including:</p>
          <ul className="list-disc list-inside">
            <li>
              Drafting, reviewing, and redrafting of consumer-facing terms.
            </li>
            <li>
              Representation before the FCC during registration or dispute
              processes.
            </li>
            <li>
              Training and legal audits for compliance officers and in-house
              counsel.
            </li>
          </ul>
        </div>
        <br />
        <i style={{ color: "#8C191B" }}>
          "This legal update is provided for general information purposes and
          does not constitute any legal advice. For tailored legal advice,
          please contact our team for assistance."
        </i>
      </div>
    </div>
  );
};

export default ArticleThree;
